import classNames from 'classnames';
import { ReactNode } from 'react';
import { ProductsCellClassType } from '@models/Products';
import * as styles from '../products-table-cell/ProductTableCell.module.scss';

interface Props {
  classType: ProductsCellClassType;
  cellKey?: string;
  children?: ReactNode;
  colSpan?: number;
}

const ProductsTableGenericCell: React.FC<Props> = ({ cellKey, classType, children, colSpan }) => {
  return (
    <td
      {...(cellKey && { key: cellKey })}
      className={classNames([
        styles.ProductTableCell__TableCell,
        styles[`ProductTableCell__TableCell_${classType}`],
        styles[`ProductTableCell__TableCell_${classType}_Wrap`],
      ])}
      colSpan={colSpan}
    >
      {children}
    </td>
  );
};

export default ProductsTableGenericCell;
